import { StyleSheet, css } from 'aphrodite'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import LandingSection from '../components/LandingSection'
import StakeholderCardSection from '../components/StakeholderCardSection'
import LandingFooter from '../components/navigation/LandingFooter'
import LandingHeader from '../components/navigation/LandingHeader'

export default function CommunityPage() {
  const navigate = useNavigate()

  const handleJoinCommunityClick = () => {
    window.scrollTo(0, 0)
    navigate('/register')
  }

  return (
    <div className={css(styles.container)}>
      <LandingHeader />
      <LandingSection
        title="A DIGITAL HOME FOR THE DUMP TRUCK INDUSTRY"
        description="The Ecosystem's Community brings together Contractors, Brokers, Sub Hauler Corp., and Drivers in one transparent, trusted, collaborative environment. The Ecosystem is not built only for productivity, but for connection, shared progress, and success."
        imageSrc="/community_hero.webp"
        imageAlt="Construction Team"
        buttonText="Join the Ecosystem"
        testimonialText="Trusted by 10,000+ operators,"
        userCount="contractors and haulers"
        onButtonClick={handleJoinCommunityClick}
        showCallToAction={false}
        subtitle="Community"
      />
      <section className={css(styles.digitalPlatformSection)}>
        <div className="flex align-center items-center gap-16 flex-col md:flex-row">
          <div className={css(styles.digitalPlatformContent)}>
            <h2 className={css(styles.digitalPlatformTitle)}>
              SHARED VALUES, COLLECTIVE IMPACT
            </h2>
            <p className={css(styles.digitalPlatformDescription)}>
              The Ecosystem is shaped by people who use it. Transparency, Trust,
              and Collaboration guide the Community how to interact, innovate,
              and push the Dump Truck industry forward.
            </p>
          </div>
          <div className={css(styles.digitalPlatformImageContainer)}>
            <img
              src="/shared_values2.webp"
              alt="Shared Values"
              className={css(styles.digitalPlatformImage)}
              loading="lazy"
            />
          </div>
        </div>
      </section>
      <StakeholderCardSection
        title="DRIVING PROGRESS TOGETHER"
        backgroundColor="#f9fafb"
      />
      <LandingSection
        title="READY TO JOIN THE COMMUNITY?"
        description="Be part of the journey that's transforming the Dump Truck Industry. Connect with Contractors, Brokers, Sub Hauler Corp., and Drivers in a trusted digital community."
        imageSrc="/ecosystem.webp"
        imageAlt="Construction Team"
        buttonText="Join the Ecosystem"
        testimonialText="Trusted by 10,000+ operators,"
        userCount="contractors and haulers"
        onButtonClick={handleJoinCommunityClick}
      />
      <LandingFooter />
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
  },
  mainContent: {
    flex: 1,
    padding: '80px 16px',
    maxWidth: '1280px',
    margin: '0 auto',
    width: '100%',
    '@media (min-width: 640px)': {
      padding: '80px 24px',
    },
    '@media (min-width: 1024px)': {
      padding: '80px 32px',
    },
  },
  digitalPlatformSection: {
    gap: '32px',
    alignItems: 'center',
    padding: '40px 1rem',
    '@media (min-width: 768px)': {
      gap: '40px',
      padding: '60px 2rem',
    },
    '@media (min-width: 1024px)': {
      gridTemplateColumns: '1fr 1fr',
      gap: '48px',
      padding: '80px 3rem',
    },
    '@media (min-width: 1280px)': {
      padding: '100px 5rem',
    },
  },
  digitalPlatformContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    textAlign: 'center',
    '@media (min-width: 768px)': {
      gap: '20px',
    },
    '@media (min-width: 1024px)': {
      gap: '24px',
      textAlign: 'left',
    },
  },
  digitalPlatformTitle: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '32px',
    fontWeight: 400,
    color: '#1F3D61',
    lineHeight: 1.2,
    '@media (min-width: 768px)': {
      fontSize: '48px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '60px',
    },
  },
  digitalPlatformDescription: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#4B5563',
    fontWeight: 400,
    '@media (min-width: 768px)': {
      fontSize: '16px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '18px',
    },
  },
  getStartedButton: {
    backgroundColor: '#6DC3FF',
    color: '#1F407E',
    padding: '12px 32px',
    borderRadius: '24px',
    fontSize: '16px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    width: '30%',
  },
  digitalPlatformImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    order: -1,
    '@media (min-width: 1024px)': {
      order: 0,
    },
  },
  digitalPlatformImage: {
    height: 'auto',
    maxHeight: '85vh',
    objectFit: 'contain',
    borderRadius: '16px',
    '@media (min-width: 768px)': {
      borderRadius: '20px',
      maxWidth: '90%',
    },
    '@media (min-width: 1024px)': {
      borderRadius: '24px',
      maxWidth: '100%',
    },
  },
})
